@if (job) {
    <div class="job">
        <!-- general -->
        <div class="job-descr">
            <div class="job-company-icon" [style.background-image]="'url(' + job.agency_icon + ')'"></div>
            <div class="job-descr-info">
                <div class="job-head">
                    <div class="job-title">{{job.project}}</div>
                    @if (!isInfo) {
                        <button class="job-more-info" (click)="info.emit(job)">{{'job_more_info' | translate}}<i></i></button>
                    }
                </div>
                @if (!job.simpleView) {
                    <div class="job-planning">
                        @if (job.hasPickup) {
                            {{'job_pick_up' | translate}} <span class="arrow">&#10140;</span>
                        }
                        @if (job.location) {
                            <span class="location"> {{job.location}} </span>
                        }
                        @if (!job.location) {
                            <span class="location-to-be-determined"> {{'job_location_tbd' | translate}} </span>
                        }
                        @if (job.hasDropoff) {
                            <span class="arrow">&#10140;</span> {{'job_drop_off' | translate}}
                        }
                    </div>
                }
                <div class="job-timing-and-type">
                    @if (!job.simpleView) {
                        <div class="job-timing">
                            <table>
                                <tr>
                                    <td>{{'job_job_start' | translate}}</td>
                                    <td>{{job.start}}</td>
                                </tr>
                                <tr>
                                    <td>{{'job_job_end' | translate}}</td>
                                    <td>{{job.end}}</td>
                                </tr>
                            </table>
                        </div>
                    }
                    @if (job.simpleView) {
                        <div class="job-title-descr">
                            <!-- temp temp temp -->
                        </div>
                    }
                    <div class="job-type">
                        {{job.typeDescr}}
                        @if (job.type) {
                            <i [style.background-image]="'url(' + '/collabor8-planning/assets/img/job-types/icon-' + job.type + '.svg' + ')'"></i>
                        }
                    </div>
                </div>
            </div>
        </div>
        @if (!isControlcenter) {
            <!-- to accept -->
            @if (toAccept) {
                <div class="job-options">
                    <button class="job-accept" [class.saving]="localSubmitting" (click)="localSubmitting = true; accept.emit(job)">{{'job_btn_accept' | translate}}</button>
                    <button class="job-decline" [class.saving]="localSubmitting" (click)="localSubmitting = true; decline.emit(job)">{{'job_btn_decline' | translate}}</button>
                </div>
            }
            <!-- is open -->
            @if (isOpen) {
                <div class="job-options applied-wrap">
                    @if (withdraw.observers?.length) {
                        <div class="applied">
                            <div class="title">{{'job_applied_title_1' | translate}} {{getTypeDescr(job.type, job.typeDescr)}}{{'job_applied_title_2' | translate}}</div>
                            <!-- <div class="descr">{{'job_applied_descr' | translate}}</div> -->
                        </div>
                    }
                    @if (apply.observers?.length) {
                        <button class="job-apply" [class.saving]="localSubmitting" (click)="localSubmitting = true; apply.emit(job)">{{'job_btn_apply' | translate}} {{getTypeDescr(job.type, job.typeDescr)}}</button>
                    }
                    @if (withdraw.observers?.length) {
                        <button class="job-withdraw" [class.saving]="localSubmitting" (click)="localSubmitting = true; withdraw.emit(job)">{{'job_btn_withdraw' | translate}}</button>
                    }
                </div>
            }
        }
        <!-- is info -->
        @if (isInfo) {
            <div class="job-info">
                @if (jobInfo.timeline) {
                    <div class="job-info--inner">
                        @if (loadingJobInfo) {
                            <app-spinner></app-spinner>
                        }
                        @if (!loadingJobInfo) {
                            <!-- timeline -->
                            @if (jobInfo?.timeline?.length) {
                                <div class="job-timeline">
                                    @for (item of jobInfo.timeline; track item) {
                                        <div class="job-timeline-item">
                                            <div class="left">
                                                {{item.time}}
                                            </div>
                                            <div class="center">
                                                <i class="timeline-icon icon-timeline-{{item.type}}"></i>
                                                <div class="line"></div>
                                            </div>
                                            <div class="right">
                                                <div class="title">{{item.label}}</div>
                                                <div class="content">
                                                    <!-- location -->
                                                    @if (item.location) {
                                                        <div (click)="clickLocation($event, item)" class="content-type content--address">
                                                            <div class="icon-wrap"><i></i></div>
                                                            <div class="content-wrap">{{item.location.address}}</div>
                                                        </div>
                                                        <!-- <a (click)="clickLocation($event, item)" [href]="'http://maps.google.com/maps?q=' + item.location.latitude + ',' + item.location.longitude" class="content-type content--address" target="_blank"> -->
                                                    }
                                                    <!-- promos -->
                                                    @if (item.promos?.length) {
                                                        <div class="content-type content--promo" target="_blank">
                                                            <div class="icon-wrap"><i></i></div>
                                                            <div class="content-wrap">
                                                                @for (promo of item.promos; track promo) {
                                                                    <div class="promo-item">
                                                                        <div class="avatar" [style.border-color]="promo.color" [style.background-image]="'url(' + promo.thumb + ')'"></div>
                                                                        <div class="right">
                                                                            <div class="name">{{promo.name}}</div>
                                                                            <div class="descr">{{promo.descr}}</div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    <!-- car -->
                                                    @if (item.type === 'car') {
                                                        <div class="content-type content--car" target="_blank">
                                                            {{item.description}}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        }
                    </div>
                }
                @if (!loadingJobInfo) {
                    <div class="job-info--foot">
                        <!-- wage -->
                        @if (jobInfo.rate) {
                            <div class="foot-row">
                                <div class="left">{{'job_foot_label_wage' | translate}}</div>
                                <div class="right">
                                    <i class="icon-wage"></i>
                                    {{jobInfo.rate}} {{'job_foot_wage_suffix' | translate}}
                                </div>
                            </div>
                        }
                        <!-- time -->
                        @if (jobInfo.duration) {
                            <div class="foot-row">
                                <div class="left">{{'job_foot_label_time' | translate}}</div>
                                <div class="right">
                                    <i class="icon-time"></i>
                                    {{jobInfo.duration}}
                                </div>
                            </div>
                        }
                        <!-- disclaimer -->
                        @if (jobInfo.rate) {
                            <div class="foot-row-disclaimer">{{'job_foot_disclaimer' | translate}}</div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}